<template>
  <!-- width="20" height="17" -->
  <path
    d='M5.77232 2.31522H6.3127L6.48375 1.80263L6.83502 0.75L13.6856 0.749999L14.0368 1.80263L14.2079 2.31522H14.7483H19.5V17.25H0.75V2.31522H5.77232Z'
    stroke='#069EE0' stroke-width='1.5' />
  <circle cx='10.125' cy='10.125' r='4.125' stroke='#069EE0' stroke-width='1.5' />
  <circle cx='3.375' cy='4.875' r='1.125' fill='#069EE0' />
</template>
